/**
 *  All api related to order-methods
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import config from '../../config'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchOrderMethods(options = {}) {
  const { page = 1, ...others } = options
  const buildNumber = config.get('appBuildNumber')
  const params = {
    page,
    buildNumber,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchOrderMethods',
    () => source.cancel('fetchOrderMethods: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'order_methods/configs',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data, cacheChecksum }) => ({
      cacheChecksum,
      orderMethods: _.get(data, 'orderMethodConfigs', {}),
      next: _.get(data, 'orderMethodsPagination.nextPage') > page
        ? () =>
          fetchOrderMethods({
            page: page + 1,
            ...others
          })
        : null,
      all: page === 1 && _.get(data, 'orderMethodsPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'orderMethodsPagination.totalPages') - 1,
            (index) => fetchOrderMethods({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'orderMethodsPagination.totalCount'),
    }))
}
